namespace GeniuzPOS.InventoryReport {
    export class IcReport01Columns {
        static columnsKey = 'InventoryReport.IcReport01';
    }
}
